import { render, staticRenderFns } from "./SitioMapPoli.vue?vue&type=template&id=21e45f9e"
import script from "./SitioMapPoli.vue?vue&type=script&lang=js"
export * from "./SitioMapPoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports